import {Route, Routes, Outlet} from 'react-router-dom';

import {PageLink, PageTitle} from '_metronic/layout/core';
import React, {useState} from "react";
import AvatarChange from "./components/avatarChange";
import FriendDuel from "./components/friendDuel";
import RandomDuel from "./components/randomDuel";
import KeysProgress from "./components/keysProgress";
import LevelUp from "./components/levelUp";

const breadcrumbs: Array<PageLink> = [
  {
    title: 'AnimationSetting',
    path: '/animation-setting',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const AnimationSettingPage = () => {
  const [activeTab, setActiveTab] = useState(1)
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          index
          element={
            <>
              <PageTitle breadcrumbs={breadcrumbs}>Animation Setting</PageTitle>
              <div className="d-flex w-100 justify-content-between gap-5 mb-10">
                <button
                    className={`btn border border-2 btn-light w-100 ${activeTab === 1 && "btn-primary"}`}
                    onClick={() => setActiveTab(1)}
                >
                  Avatar-Change for Register
                </button>
                <button
                    className={`btn border border-2 btn-light w-100 ${activeTab === 2 && "btn-primary"}`}
                    onClick={() => setActiveTab(2)}
                >
                  Friend-Duel for Duel Animation
                </button>
                <button
                    className={`btn border border-2 btn-light w-100 ${activeTab === 3 && "btn-primary"}`}
                    onClick={() => setActiveTab(3)}
                >
                  Random-Duel for Random Challenge
                </button>
                <button
                    className={`btn border border-2 btn-light w-100 ${activeTab === 4 && "btn-primary"}`}
                    onClick={() => setActiveTab(4)}
                >
                  Level-Up for Level Up Animation
                </button>
                <button
                    className={`btn border border-2 btn-light w-100 ${activeTab === 5 && "btn-primary"}`}
                    onClick={() => setActiveTab(5)}
                >
                  Keys-Progress
                </button>
              </div>
              {activeTab === 1 && <AvatarChange/>}
              {activeTab === 2 && <FriendDuel/>}
              {activeTab === 3 && <RandomDuel/>}
              {activeTab === 4 && <LevelUp/>}
              {activeTab === 5 && <KeysProgress/>}
            </>
          }
        />
      </Route>
    </Routes>
  );
};

export default AnimationSettingPage;
